//please defined your permission as unique
export const permissionUsers = [
    // {head: "Orders", label: "Add and Edit", key: "orders_add_edit", value: true},
    // {head: "Orders", label: "Delete", key: "orders_delete", value: true},
    // {head: "Orders", label: "Hide", key: "orders_hide", value: true},
    // {head: "Orders", label: "View", key: "orders_view", value: true},
    // {head: "Orders", label: "View Download", key: "orders_view_download", value: true},
    {head: "Orders", label: "Change Time Slot", key: "orders_change_time_slot", value: true},

    {head: "Users", label: "View User", key: "users_view", value: true},
    {head: "Users", label: "Create User", key: "users_add", value: true},
    {head: "Users", label: "Edit & Update User", key: "users_edit_update", value: true},

    {head: "Customers", label: "Adjust Customer Wallet", key: "customers_update_wallet", value: true},
    
    {head: "Full", label: "Full Permission", key: "full_permission", value: true}
]